export {
  getBranchReceiptPrintConfig,
  setBranchReceiptPrintConfig,
} from './infra/printConfigRepo';
export type { BranchReceiptPrintConfig, PrintJobResult, ReceiptPrintMode } from './domain/printConfig';
export { DEFAULT_BRANCH_RECEIPT_PRINT_CONFIG } from './domain/printConfig';
export {
  printSaleReceiptFromDetail,
  printSaleReceiptAfterCheckout,
  printSaleReceiptFromCheckout,
} from './application/printSaleTicket';
export {
  printSaleReceiptJob,
  shouldAutoPrintKitchenComanda,
  shouldAutoPrintSaleReceipt,
} from './application/printOrchestrator';
export {
  printKitchenComanda,
  printKitchenComandaSafe,
  retryKitchenPrintJob,
  printOrderComanda,
  printOrderComandaSafe,
  printPreCuentaDocument,
  printPreCuentaDocumentSafe,
  sharePreCuentaDocument,
  sharePreCuentaDocumentSafe,
} from './application/printComandaDocuments';
export {
  printThermalDocument,
  printThermalDocumentJob,
  isPrintUserCancellation,
} from './application/printThermalDocument';
export {
  printFiscalComprobante,
  buildFiscalReceiptPayload,
  fiscalSalePaymentConditionLabel,
} from './application/printFiscalComprobante';
export type {
  FiscalReceiptPrintInput,
  FiscalReceiptEmitterInput,
  FiscalReceiptItemInput,
} from './application/printFiscalComprobante';
export type { PrintThermalDocumentOptions } from './application/printThermalDocument';
export {
  mapSaleDetailToReceiptPayload,
  mapPosCheckoutToReceiptPayload,
} from './application/buildSaleReceiptPayload';
export {
  PRINT_AGENT_DOWNLOAD_URL,
  compareAgentVersions,
  fetchLatestAgentVersion,
  fetchPrintAgentHealth,
  fetchPrintAgentPrinters,
  isAllowedPrintAgentUrl,
} from './infra/agentClient';
export type { AgentPrinter, PrintAgentHealth } from './infra/agentClient';
export { webAgentPrintTransport } from './infra/transports/webAgentPrintTransport';
export { launchPrintAgent } from './application/launchPrintAgent';
export { resolveAgentStatus, formatLastPrintAgo } from './domain/agentStatus';
export type { AgentStatus } from './domain/agentStatus';
export { getLastPrintStatus, recordPrintOutcome } from './infra/printStatusRepo';
export type { LastPrintStatus } from './infra/printStatusRepo';
export { listKitchenPrintJobs } from './infra/kitchenPrintJobsRepo';
export type { KitchenPrintJob } from './infra/kitchenPrintJobsRepo';
export { drainKitchenPrintJobs } from './application/drainKitchenPrintJobs';
